<script setup lang="ts">
</script>

<template>
    <i class="text-[#50c3ac] w-8 h-8 block mx-auto"><svg fill="none" viewBox="0 0 32 36">
            <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5"
                d="M29.4846 15.6823V10.195c0-1.96778-1.5038-4.14351-3.3436-4.83142l-7.983-2.99163c-1.3279-.49593-3.5036-.49593-4.8314 0L5.34358 5.37958C3.50381 6.06749 2 8.24322 2 10.195v11.8865c0 1.8878 1.24784 4.3674 2.76765 5.5033l6.87915 5.1354C12.7667 33.5841 14.2545 34 15.7423 34">
            </path>
            <g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10"
                stroke-width="2.5" opacity=".4">
                <path
                    d="M25.4032 22.1188 19.74 27.7822c-.224.2239-.432.6399-.48.9438l-.304 2.1598c-.112.7839.432 1.3278 1.2159 1.2158l2.1597-.3039c.304-.048.7359-.256.9439-.48l5.6633-5.6633c.9759-.9758 1.4398-2.1117 0-3.5515-1.4238-1.4238-2.5597-.9599-3.5356.0159Z">
                </path>
                <path d="M24.5879 22.9346c.4799 1.7278 1.8238 3.0716 3.5515 3.5515"></path>
            </g>
            <path fill="currentColor" fill-rule="evenodd"
                d="M13.7925 14.8031c0-1.0767.8728-1.9496 1.9496-1.9496 1.0767 0 1.9496.8729 1.9496 1.9496s-.8729 1.9496-1.9496 1.9496c-1.0768 0-1.9496-.8729-1.9496-1.9496Zm3.1996 4.2716c1.8489-.5401 3.1996-2.2481 3.1996-4.2716 0-2.4574-1.9922-4.4496-4.4496-4.4496-2.4575 0-4.4496 1.9922-4.4496 4.4496 0 2.0235 1.3506 3.7315 3.1996 4.2716v3.7274c0 .6904.5596 1.25 1.25 1.25.6903 0 1.25-.5596 1.25-1.25v-3.7274Z"
                clip-rule="evenodd"></path>
        </svg>
    </i>
</template>